export const getHardwareId = (path) => {
  if (path.includes('md')) {
    return 'md'
  } else if (path.includes('ca')) {
    return 'ca'
  } else if (path.includes('la')) {
    return 'la'
  } else if (path.includes('va_test')) {
    return 'va_test'
  } else if (path.includes('va')) {
    return 'va'
  } else {
    return path.substring(path.lastIndexOf('/') + 1).toLowerCase()
  }
}

export const getHardwareSerial = (path) => {
  if (path.includes('la')) {
    return '2939-9CB6-0F58'
  } else if (path.includes('va')) {
    return '1925-CBC3-D1D8'
  } else if (path.includes('md')) {
    return '293B-6805-624B'
  } else if (path.includes('ca')) {
    return '2937-C84F-4A2F'
  } else {
    return ''
  }
}

export const smsURLS = {
  prod: [
    {
      id: 'md',
      url: 'https://xnnveajyse.execute-api.us-east-1.amazonaws.com/test-md',
      tz: 'America/New_York',
    },
    {
      id: 'ca',
      url: 'https://hadw57aghb.execute-api.us-east-1.amazonaws.com/test-ca',
      tz: 'America/Los_Angeles',
    },
    {
      id: 'va',
      url: 'https://96qio1b8wd.execute-api.us-east-1.amazonaws.com/test-va',
      tz: 'America/New_York',
    },
    {
      id: 'la',
      url: 'https://gh1j0330be.execute-api.us-east-1.amazonaws.com/test-la',
      tz: 'America/Chicago',
    },
  ],
  dev: [
    {
      id: 'md',
      url: 'https://g6uzx1sb1d.execute-api.us-east-1.amazonaws.com/dev-md',
      tz: 'America/New_York',
    },
    {
      id: 'ca',
      url: 'https://c9liqc0e9h.execute-api.us-east-1.amazonaws.com/dev-ca',
      tz: 'America/Los_Angeles',
    },
    {
      id: 'va',
      url: 'https://39etnfjtwl.execute-api.us-east-1.amazonaws.com/dev-va',
      tz: 'America/New_York',
    },
    {
      id: 'la',
      url: 'https://jb2msmkr99.execute-api.us-east-1.amazonaws.com/dev-la',
      tz: 'America/Chicago',
    },
  ],
}

export const getHardwareTimezone = (hardwareId) => {
  const h = smsURLS.prod.filter((i) => i.id === hardwareId)[0]
  if (h) {
    return h.tz
  }
  return 'America/New_York'
}
